module.exports = __webpack_public_path__ + "img/1ace12e.jpg";